export const lc_rule_cfg = [
  {
    id: 1,
    key: "like",
    enabled: true,
    rules: [
      {
        id: 1,
        action: "Like",
        actionKey: "like",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "it_sector",
        enabled: true,
        confidence: 0.98,
      },
      {
        id: 2,
        action: "Like",
        actionKey: "like",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "business_owner",
        enabled: true,
        confidence: 0.98,
      },
      {
        id: 3,
        action: "Like",
        actionKey: "like",
        conjunction: "if",
        ruleTarget: "likeCount",
        ruleOperator: "gt",
        ruleValue: 100,
        enabled: true,
      },
    ],
  },
  {
    id: 2,
    key: "follower",
    enabled: true,
    rules: [
      {
        id: 1,
        action: "Follow",
        actionKey: "follower",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "it_sector",
        enabled: true,
        confidence: 0.99,
      },
      {
        id: 2,
        action: "Follow",
        actionKey: "follower",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "business_owner",
        enabled: true,
        confidence: 0.99,
      },
    ],
  },
  {
    id: 3,
    key: "subscriber",
    enabled: true,
    rules: [
      {
        id: 1,
        action: "Subscribe",
        actionKey: "subscriber",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "it_sector",
        enabled: true,
        confidence: 0.99,
      },
      {
        id: 2,
        action: "Subscribe",
        actionKey: "subscriber",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "business_owner",
        enabled: true,
        confidence: 0.99,
      },
    ],
  },
  {
    id: 4,
    key: "accepter",
    enabled: true,
    rules: [
      {
        id: 1,
        action: "Accept",
        actionKey: "accepter",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "it_sector",
        enabled: true,
        confidence: 0.99,
      },
      {
        id: 2,
        action: "Accept",
        actionKey: "accepter",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "business_owner",
        enabled: true,
        confidence: 0.99,
      },
    ],
  },
  {
    id: 5,
    key: "connector",
    enabled: true,
    rules: [
      {
        id: 1,
        action: "Connect",
        actionKey: "connector",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "it_sector",
        enabled: true,
        confidence: 0.99,
      },
      {
        id: 2,
        action: "Connect",
        actionKey: "connector",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "business_owner",
        enabled: true,
        confidence: 0.99,
      },
    ],
  },
  {
    id: 6,
    key: "repost",
    enabled: true,
    rules: [
      {
        id: 1,
        action: "Repost",
        actionKey: "repost",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "it_sector",
        enabled: true,
        confidence: 0.99,
      },
      {
        id: 2,
        action: "Repost",
        actionKey: "repost",
        conjunction: "if",
        ruleTarget: "description",
        ruleOperator: "is",
        ruleIntent: "business_owner",
        enabled: true,
        confidence: 0.99,
      },
      {
        id: 3,
        action: "Repost",
        actionKey: "repost",
        conjunction: "if",
        ruleTarget: "likeCount",
        ruleOperator: "gt",
        ruleValue: 100,
        enabled: true,
      },
    ],
  },
];
